
import { defineComponent, reactive } from "vue";
import { Field, CellGroup, AddressEdit, Area, Popup } from "vant";
import { areaList } from "@vant/area-data";
import { publicSupplies, getDetail, Update } from "@/api/suppliesApi";
import { useRouter } from "vue-router";
import runEvn from "@/modular/runEvn/RunEvn";
const fileBaseUrl = runEvn().fileBaseUrl;
import { chooseImage, uploadImage, previewImage } from "@/modular/Weixinh5";
import { getForeverNewsAsync } from "@/api/WeixinH5Api";
import { powerVerify } from "@/modular/Session";

export default defineComponent({
    setup() {
        const state = reactive({
            count: 0,
            loading: false,
        });
        const router = useRouter();
        return {
            state,
            areaList,
            router,
        };
    },
    activated() {
        if (!this.id) {
            this.powerVerify();
            this.resetData();
        } else {
            this.getDetail();
            this.btnText = "保存";
        }
    },
    methods: {
        async powerVerify() {
            await powerVerify(this);
        },
        async getDetail() {
            this.suppliesInfo = await getDetail(this.id);
            this.suppliesInfo.suppliesImgsArray = [];
            if (this.suppliesInfo.suppliesImgs) {
                this.suppliesInfo.suppliesImgsArray =
                    this.suppliesInfo.suppliesImgs.split(",");
            }
            this.suppliesInfo.area = [
                { code: "0", name: "" },
                { code: "1", name: "" },
                { code: "2", name: "" },
            ];
            this.suppliesInfo.area[0].name = this.suppliesInfo.province;
            this.suppliesInfo.area[1].name = this.suppliesInfo.city;
            this.suppliesInfo.area[2].name = this.suppliesInfo.district;
            this.suppliesInfo.areaFormat = this.suppliesInfo.area
                .map((a: any) => a.name)
                .join("-");
        },
        areaConfirm(result: any) {
            this.suppliesInfo.area = result;
            this.suppliesInfo.areaFormat = result
                .map((a: any) => a.name)
                .join("-");
            this.showPopover = false;
        },
        async publicSupplies() {
            ///发布捐赠物质消息

            if (this.suppliesInfo.area.length != 3) {
                console.warn("未选择省市区");
                return;
            }

            if (this.suppliesInfo.suppliesImgsArray.length == 0) {
                this.$toast.fail("未添加图片");
                return;
            }

            this.suppliesInfo.province = this.suppliesInfo.area[0].name;
            this.suppliesInfo.city = this.suppliesInfo.area[1].name;
            this.suppliesInfo.district = this.suppliesInfo.area[2].name;
            var imgsstr = this.suppliesInfo.suppliesImgsArray.join(",");
            this.suppliesInfo.suppliesImgs = imgsstr;

            this.$toast.loading();
            if (!this.id) {
                //发布
                const data = await publicSupplies(this.suppliesInfo);
                // if (!data) {
                //     this.$toast.fail("发布失败");
                //     return;
                // }
                this.suppliesInfo.id = data.id;
                this.$toast.success("发布成功");
                // this.router.replace(
                //     `/gy/donation/details/${this.suppliesInfo.id}`
                // );
                this.router.replace(`/gy/my/DonationProject?donntionType=2`);
            } else {
                ///修改
                const isOk = await Update(this.suppliesInfo);
                if (!isOk) {
                    this.$toast.fail("保存失败");
                    return;
                }
                this.$toast.success("保存成功");
                this.router.back();
            }
        },
        img(key: string) {
            return fileBaseUrl + key;
        },
        async previewImage(imgKey: string) {
            await previewImage({
                current: this.img(imgKey),
                urls: this.suppliesInfo.suppliesImgsArray.map((item) =>
                    this.img(item)
                ),
            });
        },
        delImg(index: number) {
            this.suppliesInfo.suppliesImgsArray.splice(index, 1);
        },
        /**
         * 弹出图片选择
         */
        async chooseImage() {
            const chooseMaxImg =
                this.maxImgLen - this.suppliesInfo.suppliesImgsArray.length;
            if (chooseMaxImg <= 0) {
                this.$toast.warn("最多只能上传9张图片");
                return;
            }
            const ids = await chooseImage({
                count: chooseMaxImg, // 只能一个
                sizeType: ["compressed"], // 压缩图片
            });
            this.$toast.loading({
                message: "图片上传中...",
                forbidClick: true,
                duration: 0,
            });

            try {
                for (let index = 0; index < ids.localIds.length; index++) {
                    const localId = ids.localIds[index];
                    const media_id = await uploadImage({
                        localId: localId,
                        isShowProgressTips: 0,
                    });
                    var imgKey = await getForeverNewsAsync(media_id);
                    this.suppliesInfo.suppliesImgsArray.push(imgKey);
                }
                this.$toast.success("上传完成");
            } catch (error) {
                this.$toast.fail("上传遇到问题");
            }
        },
        resetData() {
            this.suppliesInfo = {
                donateName: "",
                phone: "",
                suppliesName: "",
                desc: "",
                province: "",
                city: "",
                district: "",
                address: "",
                supplierStatus: 1,
                suppliesImgs: "",
                suppliesImgsArray: [],
                area: [
                    { code: "0", name: "" },
                    { code: "1", name: "" },
                    { code: "2", name: "" },
                ],
                areaFormat: "",
                qty: 1,
                oldAndNew: "",
            };
        },
        async onOldNewConfirm(optData) {
            this.suppliesInfo.oldAndNew = optData.val;
            this.showOldNewPicker = false;
        },
        checkTel(value: any) {
            let regPone = null;

            let mobile = /^1[3456789]\d{9}$/; //最新16手机正则
            let tel = /^(\d{3,4}-?)?\d{8}$/; //座机
            //et tel = null;
            if (value.charAt(0) == 0) {
                // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
                regPone = tel;
            } else {
                regPone = mobile;
            }
            if (!regPone.test(value)) {
                this.errPhonemsg = "请填写联系电话(座机格式'区号-座机号码')";
                return false;
            }
            return true;
        },
    },
    name: "DonationEdit",
    components: {
        [Field.name]: Field,
        [CellGroup.name]: CellGroup,
        [AddressEdit.name]: AddressEdit,
        [Area.name]: Area,
        [Popup.name]: Popup,
    },
    props: {
        id: {
            type: String,
            //default: "1",
        },
    },
    data() {
        return {
            /**
             * 最多允许提交多少张图片
             */
            maxImgLen: 9,
            showPopover: false,
            suppliesInfo: {
                donateName: "",
                phone: "",
                suppliesName: "",
                desc: "",
                province: "",
                city: "",
                district: "",
                address: "",
                supplierStatus: 1,
                suppliesImgs: "",
                suppliesImgsArray: [],
                area: [],
                areaFormat: "",
            },
            showOldNewPicker: false,
            oldNewColumns: [
                { name: "全新", val: "全新" },
                { name: "9成新", val: "9成新" },
                { name: "8成新", val: "8成新" },
                { name: "其他", val: "其他" },
            ],
            btnText: "立刻捐赠",
            errPhonemsg: "",
        };
    },
});
